import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricUnavailability extends MetricBase {
    constructor() {
        super({
            field: "metric_not_available_rate_ratio",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.trivago.unavailability.chartName"),
            serieLabel: i18n.t("metrics.trivago.unavailability.serieLabel"),
            tooltip: i18n.t("metrics.trivago.unavailability.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricUnavailability;
